import axios from "axios";
import { SessionStore } from "../../../types/store";
import { newAbortSignal } from "../../../utils";

const BASE_URL = `${process.env.REACT_APP_BACKEND_URL}/warehouse/requisitions`;

export const downloadRequisitionTransportGuide = async (
  requisitionId: number,
): Promise<void> => {
  const session: SessionStore | undefined = JSON.parse(
    localStorage.getItem("session") || "{}",
  );

  const res = await axios.get<Blob>(
    `${BASE_URL}/${requisitionId}/transport-guide`,
    {
      headers: {
        "x-access-token": session?.accessToken,
      },
      responseType: "blob",
      timeout: Number.parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`),
      signal:
        AbortSignal.timeout === undefined
          ? newAbortSignal(Number(process.env.REACT_APP_AXIOS_TIME_OUT))
          : AbortSignal.timeout(Number(process.env.REACT_APP_AXIOS_TIME_OUT)),
    },
  );

  const blob = new Blob([res.data]);
  const url = globalThis.URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = url;
  link.download = `transport_guide_${requisitionId}.pdf`;
  link.click();
  link.remove();

  globalThis.URL.revokeObjectURL(url);
};